import React, { useRef, useEffect } from "react";
import { Container, Sprite } from "@pixi/react";
import { useSelector } from "react-redux";
import ReelFrontController, {
  STATIC_CONFIG,
  // STATIC_CONFIG_FEATURE,n
  SPINE_CONFIG,
} from "./ReelFrontController";
import { Settings } from "../../../settings";
import { selectHoldAndWinActive } from "../../../State/selectors";
import * as PIXI from "pixi.js";
import { ASSET_NAME } from "../../../assets";

const ReelFront = ({
  symbolWidth,
  symbolHeight,
  dimensions,
  dividerDimensions,
  renderMode = "static", // New prop: "spine" or "static"
}) => {
  const reelFrontControllerRef = useRef(null);
  const spriteRef = useRef(null);
  const holdAndWinActive = useSelector(selectHoldAndWinActive);

  // Initialize ReelFrontController when assets are ready (spine mode only)
  useEffect(() => {
    if (
      renderMode === "spine" &&
      spriteRef.current &&
      !reelFrontControllerRef.current
    ) {
      reelFrontControllerRef.current = new ReelFrontController(
        spriteRef.current,
        symbolWidth,
        symbolHeight,
        dimensions,
        dividerDimensions
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderMode]);

  // Handle dimension changes for responsive design (spine mode only)
  useEffect(() => {
    if (renderMode === "spine" && reelFrontControllerRef.current) {
      reelFrontControllerRef.current.resizeReelFront(
        symbolWidth,
        symbolHeight,
        dimensions,
        dividerDimensions
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbolHeight, renderMode]);

  // Calculate dimensions for static sprite with dividers and multipliers
  const dividerCount = Settings.REEL_COUNT - 1;
  const dividerWidth = dividerDimensions?.width ?? 0; // Default to 0 if not provided
  // Always use base config (decorations are now separate component)
  const config = STATIC_CONFIG;
  // Width includes dividers and multiplier
  const staticWidth =
    (symbolWidth * Settings.REEL_COUNT + dividerWidth * dividerCount) *
    config.widthMultiplier;
  const staticHeight =
    symbolHeight * Settings.SYMBOLS_VISIBLE * config.heightMultiplier;

  // Get texture for static mode (always use base texture, decorations are separate)
  const staticTexture =
    renderMode === "static"
      ? PIXI.Assets.get(ASSET_NAME.reel_frame_front_static)
      : null;

  return (
    <Container
      y={
        renderMode === "spine"
          ? -symbolHeight *
            Settings.SYMBOLS_VISIBLE *
            SPINE_CONFIG.verticalOffset
          : config.verticalOffset
      }
      x={
        renderMode === "spine"
          ? symbolWidth * Settings.REEL_COUNT * SPINE_CONFIG.horizontalOffset
          : config.horizontalOffset
      }
      ref={spriteRef}
      name="front_texture"
      zIndex={holdAndWinActive ? 6 : 4}
    >
      {renderMode === "static" && staticTexture && (
        <Sprite
          texture={staticTexture}
          width={staticWidth}
          height={staticHeight}
          zIndex={4}
          anchor={0.5}
        />
      )}
    </Container>
  );
};

export default ReelFront;
